/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import { takeLatest, put, call } from "redux-saga/effects";
import { GET_TABLE, GET_CARD, CHECK_OUT, GET_VISITOR_HISTORY } from "../action/constant";
import request from "../utils/request";
import { tzParam } from "../utils/timezone";
import {
  getTableSuccess,
  getCardSuccess,
  getCardError,
  checkOutError,
  checkOutSuccess,
  getTableRequest,
  getVisitorHistorySuccess,
  getVisitorHistoryError
} from "../action/dashboardTableAction";

const token = localStorage.getItem("token");

function* getTableSaga(action) {
  const data = JSON.parse(localStorage.getItem("building"));
  const url = `Visitor/getvisitors?buildingId=${data._id}&page=${action.data.page ||
    1}&limit=${action.data.sizePerPage || 20}&search=${action.data.search || ""}&date_from=${action
    .data.from || ""}&date_to=${action.data.to || ""}&order_by=${action.data.orderBy || ""}&status=${action
    .data.status || ""}&phone=${action.data.phone || ""}&${tzParam()}`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `VMS-2.0${token}`
      }
    });
    yield put(getTableSuccess(response.data));
  } catch (err) {
    yield put();
  }
}
/**
 * Visit history for one number, for the visitor record modal. It is a separate
 * action from getTable so that opening a record does not replace the visitors
 * table underneath it. The phone filter takes any format — the server
 * normalises it — so the number goes as it was recorded.
 */
function* getVisitorHistorySaga(action) {
  const data = JSON.parse(localStorage.getItem("building"));
  const phone = encodeURIComponent(action.data.phone || "");
  const url = `Visitor/getvisitors?buildingId=${data._id}&phone=${phone}&page=1&limit=20&${tzParam()}`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `VMS-2.0${token}`
      }
    });
    yield put(getVisitorHistorySuccess(response.data));
  } catch (err) {
    yield put(getVisitorHistoryError(err));
  }
}

function* getCardSaga() {
  const data = JSON.parse(localStorage.getItem("building"));
  const url = `Visitor/count?buildingId=${data._id}&${tzParam()}`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `VMS-2.0${token}`
      }
    });
    yield put(getCardSuccess(response.data));
  } catch (err) {
    yield put(getCardError(err));
  }
}
function* checkOutSaga(action) {
  const { employeeManagment } = JSON.parse(localStorage.getItem("building"));
  const url = `Visitor/checkout?id=${action.data.id}&type=${employeeManagment}`;
  try {
    const response = yield call(request, url, {
      method: "PUT",
      headers: {
        Authorization: `VMS-2.0${token}`
      }
    });
    yield put(checkOutSuccess(response.data));
    // Only the filters the table is currently showing. Two bugs lived here:
    // `status` was never passed, so the reload came back unfiltered and the
    // row just checked out stayed visible on the Checked in tab; and
    // `...response.data` spread the checkout endpoint's own response body
    // into the reload, turning the updated visitor's fields into query
    // parameters on Visitor/getvisitors.
    yield put(
      getTableRequest({
        page: action.data.page,
        sizePerPage: action.data.sizePerPage,
        search: action.data.search,
        from: action.data.from,
        to: action.data.to,
        orderBy: action.data.orderBy,
        status: action.data.status,
        phone: action.data.phone
      })
    );
  } catch (err) {
    yield put(checkOutError(err));
  }
}

export default function* watcherSaga() {
  yield takeLatest(GET_TABLE.PENDING, getTableSaga);
  yield takeLatest(GET_CARD.PENDING, getCardSaga);
  yield takeLatest(GET_VISITOR_HISTORY.PENDING, getVisitorHistorySaga);
  yield takeLatest(CHECK_OUT.PENDING, checkOutSaga);
}
